"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.simulateFormPost = exports.api = exports.axiosApi = exports.isLocal = void 0;
var axios_1 = require("axios");
var Analytics_1 = require("@/api/vendor/Analytics");
exports.isLocal = function () {
    return window.location.host.indexOf('localhost:3') >= 0 ||
        window.location.host.indexOf(':3000') >= 0;
};
exports.axiosApi = function () {
    var instance = axios_1.default.create({
        baseURL: '/',
        timeout: 30000,
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' },
        transformRequest: function (data, headers) {
            return JSON.stringify(data);
        },
    });
    return instance;
};
exports.api = Analytics_1.withAnalyticHandler(exports.axiosApi);
exports.simulateFormPost = function (url, token, formRows) {
    var form = document.createElement('form');
    form.style.visibility = 'hidden';
    form.method = 'POST';
    form.action = url;
    formRows.push(['XSRF', token]);
    formRows.map(function (it) {
        var elm = document.createElement('input');
        elm.name = it[0];
        elm.value = "" + it[1];
        form.appendChild(elm);
    });
    document.body.appendChild(form);
    form.submit();
};
